import React, {useContext} from "react";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";

import Button from "@mui/material/Button";
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';

import LookAiPopupContext from "./LookAiPopupContext";
import {postGenerateLookAiImage} from "../../aiApi";
import {MaterialResetImageIcon} from "../../../common/svgIcons/materialIcons";
import {IS_QKB_UI} from "../../../../config";
import {imageIsRenderedAndUserIsNotLoggedIn} from "../../aiFunctions";


const LookAIPopupGenerateButton = (props) => {

  const {postGenerateLookAiImage, aiResults, aiLoading, showLeadOverlay} = props;

  const {lookAiPopupContext} = useContext(LookAiPopupContext);

  const someResultExist = aiResults.some(res => res.resultImageUrl);
  const disabled = aiLoading
    || !lookAiPopupContext.userFile
    || !lookAiPopupContext.groupObjects
    || !lookAiPopupContext.groupObjects.some(groupObject => groupObject.enabled)
    || imageIsRenderedAndUserIsNotLoggedIn(showLeadOverlay, aiResults);

  return (
    <div className="p-1 bg-white look-ai__content w-full">
      <Button className={"rounded-025 nowrap p-0 w-full"
        + (IS_QKB_UI ? " ui-button2 ui-button2--green ui-button2--white h-25" : " look-button look-button--primary")}
              style={{fontSize: "12px"}}
              disabled={disabled}
              startIcon={someResultExist ? MaterialResetImageIcon : <ImageOutlinedIcon/>}
              onClick={() => disabled ? null : postGenerateLookAiImage(lookAiPopupContext)}>
        <FormattedMessage id={someResultExist ? "look.ai.panel.reGenerateButton" : "look.ai.panel.generateButton"}/>
      </Button>
    </div>
  )
};

LookAIPopupGenerateButton.propTypes = {
  showLeadOverlay: PropTypes.bool.isRequired,
}

const mapStateToProps = (store) => {
  const {aiResults, aiLoading} = store.aiState;

  return {
    aiResults,
    aiLoading,
  };
};

const mapDispatchToProps = {
  postGenerateLookAiImage,
};

export default connect(mapStateToProps, mapDispatchToProps)(LookAIPopupGenerateButton)
